<template lang="pug">
.send-message-read-families-modal
  b-modal(v-model="_value" size="lg" no-close-on-backdrop no-close-on-esc)
    template(#modal-header="{ cancel }")
      .send-message-read-families-modal-header(style="width:100%;")
        .d-flex.justify-content-end.flex-fill
          button.btn(@click="onDownload" type="button") ダウンロード
      button.close(type="button" @click="cancel") ×

    .send-message-read-families-modal-table
      .thead
        .header-line
          .th.room-name 部屋名
          .th.redident-name 利用者名
          .th.family-name 家族ユーザー名
          .th.position 役割
          .th.tel 電話番号
      .tbody
        .body-line(v-for="family in families")
          .td.room-name {{ family.room }}
          .td.redident-name {{ family.name }}
          .td.family-name {{ family.familyName }}
          .td.position(v-if="family.familyPosition") {{ family.familyPosition }}
          .td.position(v-else) 未設定
          .td.tel {{ family.familyTel }}

    template(#modal-footer="{ cancel }")
      b-button.btn.modal-ok-btn(@click="cancel") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { FamilyGetModel } from "@/commons/services/Families";

/**
 * ### 家族詳細表示モーダル
 */
@Component
export default class SendMessageReadFamiliesModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;

  /** 表示対象の家族 */
  @Prop({ required: true })
  families!: Array<FamilyGetModel>;

  @Prop()
  csvTypeName!: string;

  @Prop()
  csvTitle!: string;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * ### PDFダウンロードボタン押下イベント
   */
  public async onDownload(): Promise<void> {
    const csv: string = this.createCsv(this.families);
    this.downloadCsv(csv, `HitomeQコネクト-アンケート-${this.csvTitle}-${this.csvTypeName}.csv`);
    return;
  }

  /**
   * ### イベント申込のCSVを作成する
   */
  public createCsv(families: Array<FamilyGetModel>): string {
    const csv: string[] = [];
    csv.push("\ufeff" + `部屋名,利用者名,家族ユーザー名,役割,電話番号`);

    for (const item of families) {
      const room: string = item.room;
      const residentName: string = item.name;
      const familyName: string = item.familyName;
      const familyPosition: string = item.familyPosition ? item.familyPosition : "未設定";
      const familyTel: string = item.familyTel;

      csv.push(`${room},${residentName},${familyName},${familyPosition},="${familyTel}"`);
    }

    return csv.join("\n");
  }

  /**
   * ### CSVファイルをダウンロードさせる
   *
   * - CSVの内容からblobファイルを作成する
   * - blobファイルの種別はtext/csv
   * - a要素を作ってそれを疑似的にクリックさせることでダウンロードさせる
   */
  public downloadCsv(csv: string, fileName: string): void {
    const blob: Blob = new Blob([csv], { type: "text/csv" });

    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    return;
  }
}
</script>
